/**
 *
 * Asynchronously loads the component for Sap003
 * Author: Annt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
